import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Style from "../Style/Adminpage.module.scss";

function Adminpage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const baseURL = process.env.REACT_APP_BASE_URL;

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch(`${baseURL}/admin/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await res.json();

      if (res.ok) {
        localStorage.setItem("adminAuth", true);
        alert("Login successful!");
        navigate("/admin/dashboard");
      } else {
        alert(data.message || "Login failed!");
      }
    } catch (error) {
      console.error("Login error:", error);
      alert("Something went wrong");
    }
  };

  return (
    <div className={Style.adminLoginContainer}>
      <h2>Admin Login</h2>
      <form onSubmit={handleLogin} className={Style.adminLoginForm}>
        <div className={Style.inputGroup}>
          <label>Email</label>
          <input
            type="email"
            placeholder="Enter email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        <div className={Style.inputGroup}>
          <label>Password</label>
          <input
            type="password"
            placeholder="Enter password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>

        <button type="submit" className={Style.loginButton}>
          Login
        </button>
      </form>
    </div>
  );
}

export default Adminpage;
